import { createComponent } from '@carvana/merch-components';

export const Card = createComponent('div', {
  className: 'flex flex-col gap-24 sm:gap-32'
});

export const ContentSection = createComponent('div', {
  className: 'flex flex-col gap-24'
});

export const Headline = createComponent('h2', {
  className:
    'flex flex-col text-white t-brand-sm sm:t-brand-md md:t-brand-lg m-0'
});

export const TaskWarning = createComponent('div', {
  className: 'flex flex-row items-center gap-md'
});

export const BodyText = createComponent('p', {
  className: 'text-white t-body-sm m-0 max-w-[440px]'
});

export const VehicleSection = createComponent('div', {
  className: 'flex flex-col gap-24'
});

export const VehicleInfo = createComponent('div', {
  className: 'flex flex-col gap-4'
});

export const VehicleTitle = createComponent('p', {
  className: 'text-white t-heading-md m-0'
});

export const VehicleSubText = createComponent('div', {
  className: 'flex flex-row flex-wrap items-center gap-8 text-white t-body-sm'
});
